import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { List, Empty, Space, Typography, Button, Card, Row, Col } from "antd";
import { StudentNotification } from "interfaces/students";
import { message } from "components/Messages/Messages";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"; // Import FontAwesome icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NotificationBox from "./NotificationBox/NotificationBox";

const { Title } = Typography;

const Notifications = () => {
  const history = useHistory();
  const [notifications, setNotifications] = useState<StudentNotification[]>([]);
  const [unread, setUnread] = useState<StudentNotification[]>([]);
  const [fetchingNotifications, setFetchingNotifications] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleButtonClick = () => {
    history.push("/student-profile");
  };

  useEffect(() => {
    axios
      .get<StudentNotification[]>("/students/student-notifications/")
      .then(response => {
        setNotifications(response.data);
        setUnread(response.data.filter(n => !n.read_at));
      })
      .finally(() => setFetchingNotifications(false));
  }, []);

  const markAllAsRead = async () => {
    try {
      setLoading(true);
      const responses = await Promise.all(
        unread.map(not => axios.post<StudentNotification>(`/students/student-notifications/${not.id}/read/`))
      );
      message("success", "Notifikasjoner markert som lest");
      const updatedNotifications = notifications.map(n => {
        const updated = responses.find(res => res.data.id === n.id);
        return updated ? updated.data : n;
      });
      setNotifications(updatedNotifications);
      setUnread([]);
    } catch {
      message("error", "Notifikasjoner kunne ikke markeres som lest");
    } finally {
      setLoading(false);
    }
  };

  const notificationBoxes = notifications.map(notification => {
    return <NotificationBox key={notification.id} notification={notification} />;
  });

  return (
    <>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Card style={{ width: "80%" }}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row align="middle" style={{ paddingBottom: "2em" }}>
              <Col>
                <Button style={{ width: "3.5rem", height: "3rem", fontSize: "1.5rem" }} onClick={handleButtonClick}>
                  <FontAwesomeIcon icon={faArrowLeft} />
                </Button>
              </Col>
              <Col>
                <Title style={{ margin: 0, paddingLeft: "1rem" }}>Notifikasjoner</Title>
              </Col>
            </Row>
            {unread.length > 0 ? (
              <Button style={{ marginBottom: "20px" }} type="primary" onClick={markAllAsRead} loading={loading}>
                Merk alle som lest
              </Button>
            ) : null}
          </Space>

          <List
            loading={fetchingNotifications}
            itemLayout="vertical"
            pagination={false}
            locale={{
              emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Du har ingen notfikasjoner" />,
            }}
            style={{ padding: 0, margin: 0 }}
            dataSource={notificationBoxes}
            renderItem={item => item}
          />
        </Card>
      </div>
    </>
  );
};

export default Notifications;
